import MapboxDraw from "@mapbox/mapbox-gl-draw";


MapboxDraw.constants.cursors.MOVE = MapboxDraw.constants.cursors.POINTER

const limited_direct_select = {

	onFeature:function(state, e) {
		this.stopDragging(state);
	},

	dragVertex: function(state, e, delta) {
		const selectedCoords = state.selectedCoordPaths.map(coord_path => state.feature.getCoordinate(coord_path));
		const selectedCoordPoints = selectedCoords.map(coords => ({
			type: MapboxDraw.constants.geojsonTypes.FEATURE,
			properties: {},
			geometry: {
			  type: MapboxDraw.constants.geojsonTypes.POINT,
			  coordinates: coords
			}
		}));
		const oldCoords = selectedCoords;
		var newCoords = [];

		const constrainedDelta = MapboxDraw.lib.constrainFeatureMovement(selectedCoordPoints, delta);
		for (let i = 0; i < selectedCoords.length; i++) {
		  const coord = selectedCoords[i];
		  newCoords.push(coord[0] + constrainedDelta.lng, coord[1] + constrainedDelta.lat);
		  state.feature.updateCoordinate(state.selectedCoordPaths[i], coord[0] + constrainedDelta.lng, coord[1] + constrainedDelta.lat);
		}
		state.feature.ctx.map.fire("draw.updatevertex", {oldCoords: oldCoords, newCoords:newCoords, featureId: state.featureId});
	}
}

export default limited_direct_select;